import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';
import { CareRecommendationRecommendation } from 'src/generated/webapp_gql';
import { getMyTherapists } from 'src/modules/providers/selectors/providersSelectors';
import { getMostRecentCareRecommendation, getUserInformation } from '../selectors/userSelectors';

export const useDoesUserQualifyForTherapy = (): boolean => {
    const mostRecentCareRecommendation = useSelector(getMostRecentCareRecommendation);
    const { showTherapyForAll } = useFlags();
    const myTherapists = useSelector(getMyTherapists);

    return (
        myTherapists?.length === 0 &&
        (!!showTherapyForAll ||
            mostRecentCareRecommendation?.recommendation ===
                CareRecommendationRecommendation.Therapy)
    );
};

// used only in the onboarding
export const useShouldTakeToRequestPersonalEmailAddressFlow = (): boolean => {
    const { hideRequestPersonalEmailFlowWeb } = useFlags();
    const { email, eligiblePersonEmail, isActiveCobraRifMember } = useSelector(getUserInformation);

    if (isActiveCobraRifMember && email === eligiblePersonEmail) {
        return true;
    }

    if (hideRequestPersonalEmailFlowWeb) {
        return false;
    }

    // we don't have information about user's work email address
    // so we can't detect if the user has already changed it or not
    if (!eligiblePersonEmail) {
        return false;
    }

    // return true only if user's email address is still the same as work one
    return eligiblePersonEmail === email;
};

// will return true only if email address change is required by a company
// used outside of the onboarding (for existing users)
// For COBRA/RIF members it is a requirement to show this flow
export const useShouldTakeToRequestPersonalEmailAddressFlowRequiredOnly = (): boolean => {
    const { workEmailAddressChangeRequired } = useFlags();
    const { email, isActiveCobraRifMember, eligiblePersonEmail } = useSelector(getUserInformation);
    const shouldTake = useShouldTakeToRequestPersonalEmailAddressFlow();

    if (isActiveCobraRifMember && email === eligiblePersonEmail) {
        return true;
    }
    return !!workEmailAddressChangeRequired && shouldTake;
};
